<template>
    <div class="min-h-screen bg-zinc-50 text-slate-700 font-inter">
        <slot />
    </div>
</template>
